import profileRoutes from '@/router/profile-routes';

export default [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'intro' },
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('@/views/NotFound'),
  },
  {
    path: '/intro',
    name: 'intro',
    component: () => import('@/views/Intro/Intro'),
    meta: {
      title: 'Intro',
    },
  },
  {
    path: '/main-menu',
    name: 'main-menu',
    component: () => import('@/views/MainMenu/MainMenu'),
    meta: {
      title: 'MainMenu',
      showMenuWidget: false,
    },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/Welcome/Welcome'),
    meta: {
      title: 'Welcome',
    },
  },
  {
    path: '/welcome-back',
    name: 'welcome-back',
    component: () => import('@/views/WelcomeBack/WelcomeBack'),
    meta: {
      title: 'Welcome Back',
    },
  },
  {
    path: '/game-type-picker',
    name: 'game-type-picker',
    component: () => import('@/views/GameTypePicker/GameTypePicker'),
    meta: {
      title: 'Game Picker',
    },
  },
  {
    path: '/games/continue',
    name: 'games-continue',
    component: () => import('@/views/AutoContinue/AutoContinue'),
    meta: {
      title: 'Continue',
    },
  },
  {
    path: '/next-game',
    name: 'next-game',
    component: () => import('@/views/NextGamePicker/NextGamePicker'),
    meta: {
      title: 'Next Game',
    },
  },
  {
    path: '/badges',
    name: 'badges',
    component: () => import('@/views/BadgesPage/Badges'),
    meta: {
      title: 'Badges',
    },
  },
  {
    path: '/newgame',
    name: 'newgame',
    component: () => import('@/views/CreateProfileFlow/ProfileCreation'),
    meta: {
      title: 'Character Creation',
    },
  },
  {
    path: '/rpg', // TODO refactor page (authorize actions)
    name: 'rpg',
    component: () => import('@/components/rpg/rpg'),
    meta: {
      title: 'RPG',
    },
  },
  {
    path: '/games', // TODO refactor page (authorize actions)
    name: 'games',
    component: () => import('@/views/GameList/BrowseGames'),
    meta: {
      title: 'Games',
    },
  },
  {
    path: '/game/:id', // TODO refactor page (authorize actions)
    name: 'game',
    component: () => import('@/views/Game'),
    meta: {
      title: 'Game',
    },
  },
  {
    path: '/game/view/:id', // TODO refactor page (authorize actions)
    name: 'game-view',
    component: () => import('@/views/GameList/GameView'),
  },
  {
    path: '/profile',
    redirect: { name: 'profile' },
    component: () => import('@/views/Profile/ProfileLayout'),
    children: profileRoutes,
  },
];
